module.exports = __webpack_public_path__ + "media/assets/icons/help-with-circle-bb08f142da113fc738e506f2f58f382a.svg";